var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"outer",staticClass:"inline-vimeo-wrapper"},[_c('div',{ref:"inner",staticClass:"inline-vimeo-inner"},[_c('iframe',{attrs:{"data-src":_vm.json.src,"frameborder":"0"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }